module.exports = __webpack_public_path__ + "static/media/culture.a1cee5ae.jpg";